<p-messages [(value)]="msgs"></p-messages>
<div class="grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [columns]="cols" [value]="planOrganizacionesFiltered" dataKey="id"
                     selectionMode="{{appConfig.ux.table.selectionMode}}" 
                     [(selection)]="planOrganizacionesSelected"
                     rows="{{appConfig.ux.table.rows}}" 
                     paginator="{{appConfig.ux.table.paginator}}" 
                     [scrollable]="appConfig.ux.table.scrollable"
                     [scrollHeight]="appConfig.ux.table.scrollHeight"
                     filterDelay="{{appConfig.ux.table.filterDelay}}" 
                     [globalFilterFields]="globalFilterFields"
                     sortMode="{{appConfig.ux.table.sortMode}}" 
                     [multiSortMeta]="multiSortMeta"
                     showCurrentPageReport="{{appConfig.ux.table.showCurrentPageReport}}"
                     currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <!--scrollable="{{appConfig.ux.table.scrollable}}"
                scrollHeight="{{appConfig.ux.table.scrollHeight}}"-->
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <button pButton pRipple
                                type="button" 
                                label="{{ appConfig.ux.actions.create }}"
                                icon="pi pi-plus"
                                (click)="nuevoPlanOrganizacion()">
                            <!--[disabled]="!puedeEjecutar('crear')"-->
                        </button>
                        <span class="p-input-icon-left ml-1 w-full">
                            <i class="pi pi-search"></i>
                            <input
                                pInputText
                                type="text"
                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{appConfig.ux.searchMsg}}" 
                                class="w-full"/>
                        </span>
                        <p-dropdown *ngFor="let item of filtros"
                                    [options]="item.value" optionLabel="name"
                                    placeholder="{{item.name}}"
                                    (onChange)="filtrar($event, item.key)">
                        </p-dropdown>  
                        <button pButton pRipple
                                type="button" 
                                icon="pi pi-refresh" class="p-button-secondary"
                                (click)="filtrar($event, $event)">
                        </button>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="w-1rem flex-none"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                        [hidden]="!col.visible" [ngClass]="col.class">
                        {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                    <th class="w-6rem flex-none">{{appConfig.ux.actions.actions}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                    <tr>
                        <td class="w-1rem flex-none"><p-tableCheckbox [value]="rowData"></p-tableCheckbox></td>
                    <td
                        *ngFor="let col of columns" 
                        [hidden]="!col.visible" [ngClass]="col.class">
                        <span *ngIf="col.field == 'vigente' || col.field == 'pagado'"  
                              pTooltip="{{rowData[col.field] ? appConfig.ux.status.enabled : appConfig.ux.status.disabled}}" tooltipPosition="bottom">
                            <i class="{{rowData[col.field] ? 'pi pi-check-circle text-green-600 text-4xl' : 'pi pi-times-circle text-pink-600 text-4xl'}}"></i>
                        </span>
                        <span *ngIf="col.field == 'precio'">
                            $ {{rowData[col.field] ? rowData[col.field].toFixed(2) : appConfig.ux.undefinedNumber}}
                        </span>
                        <span *ngIf="col.field == 'createdOn'">
                            {{rowData[col.field] | date: 'dd/MM/yyyy'}}
                        </span>
                        <span *ngIf="col.field != 'vigente' && col.field != 'pagado' && col.field != 'precio' && col.field != 'createdOn'">
                            {{rowData[col.field]}}
                        </span>
                    </td>
                    <td class="w-6rem flex-none">
                    <p-button
                        pTooltip="{{ appConfig.ux.actions.actions }}" tooltipPosition="bottom"
                        styleClass="p-button-text p-button-rounded"
                        (click)="presentarOpcionesActionSheet($event, rowData); op.toggle($event)">
                        <ng-template pTemplate="content">
                            <img alt="acciones" src="assets/layout/icons/tap.png" class="h-2rem" />
                        </ng-template>
                    </p-button>
                    </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr><td [attr.colspan]="columns.length">{{appConfig.ux.emptyMsg}}</td></tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton pRipple
                            type="button"
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-secondary p-button-text p-button-rounded"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de acciones--->
<p-overlayPanel #op 
                [style]="{ width: '15vw' }"
                [showCloseIcon]="false">
    <ng-template pTemplate>
        <div class="p-fluid p-formgrid p-grid">
            <button
                *ngFor="let item of buttonsActions; let i = index"
                pButton
                type="button"
                [label]="item.text"
                [icon]="item.icon"
                [class]="item.cssClass"
                (click)="ejecutarAccion($event, item.action, item.data); op.hide($event)"
                [disabled]="item.disabled"></button>
        </div>
    </ng-template>
</p-overlayPanel>
<!-- Diálogos de creación/edición de planOrganizacion -->
<p-dialog
    [header]="planOrganizacion && planOrganizacion.id ? appConfig.ux.actions.edit : appConfig.ux.actions.create + ' Plan de Organización'"
    [(visible)]="mostrarEditor"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '85vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="mostrarEditor = false">
    <form #planEditorForm="ngForm"
          (ngSubmit)="guardarPlanOrganizacion()"
          [ngClass]="{ disabledForm: false }"><!--planEditorForm-->
        <p-messages [(value)]="msgs"></p-messages>
        <p-tabView [(activeIndex)]="index">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i [class]="index==0 ? 'pi pi-circle-fill mr-1' : 'pi pi-circle mr-1'"></i>
                    <span>Facturación Electrónica</span>
                    <span class="required-asterisk" *ngIf="!planEditorForm.valid || !planOrganizacion.aceptaTerminosCondiciones">*</span>
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12">
                            <h2 class="uppercase">{{planOrganizacion.organizacionName}}  <span class="text-blue-700"> {{planOrganizacion.planName  ? (' Plan '+planOrganizacion.planName) : ''}}</span> </h2>
                        </div>
                        <div class="field col-12">
                            <p-button styleClass="p-button-outlined p-button-plain"
                                      (click)="activePopupSubjects($event, (planOrganizacion && planOrganizacion.id))"
                                      [disabled]="(planOrganizacion && planOrganizacion.id)">
                                <ng-template pTemplate="content">
                                    <div class="col-12">
                                        <div class="flex align-items-center justify-content-between">
                                            {{(planOrganizacion.subject && planOrganizacion.subject.initials) ? planOrganizacion.subject.initials : 'Cliente...'}}
                                            <i class="pi pi-user-edit"></i>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-button>
                        </div>
                        <div class="field col-12">
                            <p-autoComplete inputId="plan" name="plan"
                                            [(ngModel)]="planOrganizacion.plan"
                                            [suggestions]="planesFiltered" [itemSize]="34"
                                            (completeMethod)="filteredPlanes($event)" field="name"
                                            (onSelect)="cargarDataPlan($event)"
                                            placeholder="Seleccione un plan..." 
                                            [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                            [minLength]="3" [dropdown]="true"
                                            [forceSelection]="true"
                                            [virtualScroll]="true"
                                            [disabled]="(planOrganizacion && planOrganizacion.id && false)"
                                            required>
                                <ng-template let-item pTemplate="item">
                                    <div>{{item.name}}</div>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label for="preciofrm">Precio</label>
                            <p-inputNumber 
                                #preciofrm="ngModel" id="preciofrm" name="preciofrm" 
                                [(ngModel)]="planOrganizacion.precio"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0"
                                mode="currency" currency="USD"
                                required>
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['preciofrm'] &&
                                !planEditorForm.controls['preciofrm'].valid &&
                                (planEditorForm.controls['preciofrm'].dirty || 
                                planEditorForm.controls['preciofrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label for="maximumfrm">Número Máximo Comprobantes</label>
                            <p-inputNumber 
                                #maximumfrm="ngModel" id="maximumfrm" name="maximumfrm" 
                                [(ngModel)]="planOrganizacion.maximoComprobantes"
                                (ngModelChange)="actualizarUmbralAlertasRecargas()"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0"
                                [pattern]="appConfig['validationRegExp']['numberPattern']"
                                required>
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['maximumfrm'] &&
                                !planEditorForm.controls['maximumfrm'].valid &&
                                (planEditorForm.controls['maximumfrm'].dirty || 
                                planEditorForm.controls['maximumfrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-3"
                             *ngIf="planOrganizacion.id">
                            <label for="max">Número Comprobantes Emitidos</label>
                            <p-inputNumber 
                                #emitfrm="ngModel" id="emitfrm" name="emitfrm" 
                                [(ngModel)]="planOrganizacion.numeroComprobantesEmitidos"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0"
                                [pattern]="appConfig['validationRegExp']['numberPattern']"
                                required>
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['emitfrm'] &&
                                !planEditorForm.controls['emitfrm'].valid &&
                                (planEditorForm.controls['emitfrm'].dirty ||
                                planEditorForm.controls['emitfrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label for="recarga">Umbral para Alertar Recarga</label>
                            <p-inputNumber 
                                #recargafrm="ngModel" id="recargafrm" name="recargafrm" 
                                [(ngModel)]="planOrganizacion.minimoComprobantesAlertarRecarga"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0" [max]="planOrganizacion.maximoComprobantes"
                                [pattern]="appConfig['validationRegExp']['numberPattern']"
                                required>
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['recargafrm'] &&
                                !planEditorForm.controls['recargafrm'].valid &&
                                (planEditorForm.controls['recargafrm'].dirty ||
                                planEditorForm.controls['recargafrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="fechaIniciofrm">Fecha de Inicio</label>
                            <p-calendar #fechaIniciofrm="ngModel" inputId="fechaIniciofrm" name="fechaIniciofrm"
                                        [(ngModel)]="planOrganizacion.fechaInicio"
                                        (onSelect)="cargarDataPlanFechas($event)"
                                        (onInput)="cargarDataPlanFechas($event)"
                                        [minDate]="minDate" [maxDate]="planOrganizacion.fechaFin" 
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion|| !planOrganizacion.plan)"
                                        required>
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="fechaFinfrm">Fecha de Finalización</label>
                            <p-calendar #fechaFinfrm="ngModel" inputId="fechaFinfrm" name="fechaFinfrm"
                                        [(ngModel)]="planOrganizacion.fechaFin"
                                        [minDate]="planOrganizacion.fechaInicio"
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion|| !planOrganizacion.plan || !planOrganizacion.fechaInicio)"
                                        required>
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-12">
                            <label for="fechaFinfrm">Fecha de registro</label>
                            <p-calendar #fechaFinfrm="ngModel" inputId="createOnfrm" name="createOnfrm"
                                        [(ngModel)]="planOrganizacion.createdOn"
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="false" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="true"
                                        required>
                            </p-calendar>
                        </div>
                        <div class="field col-12">
                            <p-toggleButton #aceptaTerminosCondicionesfrm="ngModel" inputId="aceptaTerminosCondicionesfrm" name="aceptaTerminosCondicionesfrm"
                                            [(ngModel)]="planOrganizacion.aceptaTerminosCondiciones" 
                                            onIcon="pi pi-check" offIcon="pi pi-times" 
                                            onLabel="{{appConfig.ux.actions.acceptTerm}}"
                                            offLabel="{{appConfig.ux.actions.acceptTerm}}"
                                            [class]="planOrganizacion.aceptaTerminosCondiciones ? 'p-togglebutton-accept' : ''"
                                            required>
                            </p-toggleButton>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i [class]="index==1 ? 'pi pi-circle-fill mr-1' : 'pi pi-circle mr-1'"></i>
                    <span>Firma Electrónica</span>
                    <span class="required-asterisk" *ngIf="(planOrganizacion && planOrganizacion.planIdTipoFirma && !planEditorForm.valid)">*</span>
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12">
                            <h2 class="uppercase">{{planOrganizacion.organizacionName}} <span class="text-yellow-700"> {{planOrganizacion.planIdTipoFirma  ? (' Plan '+planOrganizacion.planTipoFirmaName) : 'No posee plan de firma electrónica.'}}</span> </h2>
                        </div>
                        <div class="field col-12">
                            <p-autoComplete inputId="planTipoFirma" name="planTipoFirma"
                                            [(ngModel)]="planOrganizacion.planTipoFirma"
                                            [suggestions]="planesFiltered" [itemSize]="34"
                                            (completeMethod)="filteredPlanesTipoFirma($event)" field="name"
                                            (onSelect)="cargarDataPlanTipoFirma($event)"
                                            placeholder="Seleccione un plan..." 
                                            [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                            [minLength]="3" [dropdown]="true"
                                            [forceSelection]="true"
                                            [virtualScroll]="true"
                                            [disabled]="(planOrganizacion && planOrganizacion.planTipoFirma && planOrganizacion.planTipoFirma.id)">
                                <ng-template let-item pTemplate="item">
                                    <div>{{item.name}}</div>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                        <div class="field col-12">
                            <label for="planTipoFirmaPreciofrm">Precio</label>
                            <p-inputNumber 
                                #planTipoFirmaPreciofrm="ngModel" id="planTipoFirmaPreciofrm" name="planTipoFirmaPreciofrm" 
                                [(ngModel)]="planOrganizacion.planTipoFirmaPrecio"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0"
                                mode="currency" currency="USD"
                                [attr.required]="(planOrganizacion && planOrganizacion.planIdTipoFirma)">
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['planTipoFirmaPreciofrm'] &&
                                !planEditorForm.controls['planTipoFirmaPreciofrm'].valid &&
                                (planEditorForm.controls['planTipoFirmaPreciofrm'].dirty || 
                                planEditorForm.controls['planTipoFirmaPreciofrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="planTipoFirmaFechaIniciofrm">Fecha de Inicio</label>
                            <p-calendar #planTipoFirmaFechaIniciofrm="ngModel" inputId="planTipoFirmaFechaIniciofrm" name="planTipoFirmaFechaIniciofrm"
                                        [(ngModel)]="planOrganizacion.planTipoFirmaFechaInicio"
                                        (onSelect)="cargarDataPlanFechas($event)"
                                        (onInput)="cargarDataPlanFechas($event)"
                                        [minDate]="minDate" [maxDate]="planOrganizacion.planTipoFirmaFechaFin" 
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion|| !planOrganizacion.planTipoFirma)"
                                        [attr.required]="(planOrganizacion && planOrganizacion.planIdTipoFirma)">
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="planTipoFirmaFechaFinfrm">Fecha de Finalización</label>
                            <p-calendar #planTipoFirmaFechaFinfrm="ngModel" inputId="planTipoFirmaFechaFinfrm" name="planTipoFirmaFechaFinfrm"
                                        [(ngModel)]="planOrganizacion.planTipoFirmaFechaFin"
                                        [minDate]="planOrganizacion.planTipoFirmaFechaInicio"
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion || !planOrganizacion.planTipoFirma || !planOrganizacion.planTipoFirmaFechaInicio)"
                                        [attr.required]="(planOrganizacion && planOrganizacion.planIdTipoFirma)">
                            </p-calendar>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i [class]="index==1 ? 'pi pi-circle-fill mr-1' : 'pi pi-circle mr-1'"></i>
                    <span>Módulo agendamiento</span>
                    <span class="required-asterisk" *ngIf="(planOrganizacion && planOrganizacion.planAgendamientoId && !planEditorForm.valid)">*</span>
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12">
                            <h2 class="uppercase">{{planOrganizacion.organizacionName}} <span class="text-yellow-700"> {{planOrganizacion.planAgendamientoId  ? (' Plan '+planOrganizacion.planAgendamientoName) : 'No tiene asignado un plan de agendamiento.'}}</span> </h2>
                        </div>
                        <div class="field col-12">
                            <p-autoComplete inputId="planAgendamiento" name="planAgendamiento"
                                            [(ngModel)]="planOrganizacion.planAgendamiento"
                                            [suggestions]="planesFiltered" [itemSize]="34"
                                            (completeMethod)="filteredPlanesAgendamiento($event)" field="name"
                                            (onSelect)="cargarDataPlanAgendamiento($event)"
                                            placeholder="Seleccione un plan de agendamiento..."
                                            [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                            [minLength]="3" [dropdown]="true"
                                            [forceSelection]="true"
                                            [virtualScroll]="true"
                                            [disabled]="(false && planOrganizacion && planOrganizacion.planAgendamiento && planOrganizacion.planAgendamiento.id)">
                                <ng-template let-item pTemplate="item">
                                    <div>{{item.name}}</div>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                        <div class="field col-12">
                            <label for="planTipoFirmaPreciofrm">Precio</label>
                            <p-inputNumber 
                                #planAgendamientoPreciofrm="ngModel" id="planAgendamientoPreciofrm" name="planAgendamientoreciofrm" 
                                [(ngModel)]="planOrganizacion.planAgendamientoPrecio"
                                placeholder="{{appConfig.ux.undefinedNumber}}"
                                [showButtons]="true" [min]="0"
                                mode="currency" currency="USD"
                                [attr.required]="(planOrganizacion && planOrganizacion.planAgendamientoId)">
                            </p-inputNumber>
                            <p-message
                                severity="error"
                                [text]="appConfig['validationMsgs']['numberPattern']"
                                *ngIf="planEditorForm.controls['planAgendamientoPreciofrm'] &&
                                !planEditorForm.controls['planAgendamientoPreciofrm'].valid &&
                                (planEditorForm.controls['planAgendamientoPreciofrm'].dirty || 
                                planEditorForm.controls['planAgendamientoPreciofrm'].touched)">
                            </p-message>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="planAgendamientoFechaIniciofrm">Fecha de Inicio</label>
                            <p-calendar #planAgendamientoFechaIniciofrm="ngModel" inputId="planAgendamientoFechaIniciofrm" name="planAgendamientoFechaIniciofrm"
                                        [(ngModel)]="planOrganizacion.planAgendamientoFechaInicio"
                                        (onSelect)="cargarDataPlanFechas($event)"
                                        (onInput)="cargarDataPlanFechas($event)"
                                        [minDate]="minDate" [maxDate]="planOrganizacion.planAgendamientoFechaFin" 
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion|| !planOrganizacion.planAgendamiento)"
                                        [attr.required]="(planOrganizacion && planOrganizacion.planAgendamientoId)">
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label for="planAgendamientoFechaFinfrm">Fecha de Finalización</label>
                            <p-calendar #planAgendamientoFechaFinfrm="ngModel" inputId="planAgendamientoFechaFinfrm" name="planAgendamientoFechaFinfrm"
                                        [(ngModel)]="planOrganizacion.planAgendamientoFechaFin"
                                        [minDate]="planOrganizacion.planAgendamientoFechaInicio"
                                        [showTime]="appConfig.ux.calendar.showTime"
                                        [showIcon]="appConfig.ux.calendar.showIcon" 
                                        [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                                        dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                                        placeholder="{{appConfig.ux.calendar.dateFormat}}"
                                        [disabled]="(!planOrganizacion || !planOrganizacion.planAgendamiento || !planOrganizacion.planAgendamientoFechaInicio)"
                                        [attr.required]="(planOrganizacion && planOrganizacion.planAgendamientoId)">
                            </p-calendar>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button
                    pButton pRipple
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times" class="p-button-secondary"
                    (click)="mostrarEditor = false">
                </button>
                <button
                    pButton pRipple
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check" class="ml-1"
                    [disabled]="(!planEditorForm.valid || !planOrganizacion.aceptaTerminosCondiciones)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!-- Diálogos de pago de planOrganizacion -->
<p-dialog
    [header]="'Detalle de pago'"
    [(visible)]="mostrarFormaPagoSubject"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '85vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="mostrarFormaPagoSubject = false">
    <form #detallePagoForm="ngForm"
          (ngSubmit)="guardarDetallePago()"
          [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid grid" [style]="{ height: '500px' }">
            <div class="field col-12">
                <h2 class="uppercase">{{ planOrganizacion.organizacionName }}</h2>
            </div>
            <div class="field col-12">
                <label for="detalle">Detalle de pago</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bars"></i>
                    <textarea 
                        #detalle="ngModel" id="detalle" name="detalle"
                        type="text"
                        [(ngModel)]="planOrganizacion.detallePago"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        rows="5" cols="30"
                        required
                        pInputTextarea></textarea>
                </span> 
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="detallePagoForm.controls['detalle'] &&
                    !detallePagoForm.controls['detalle'].valid &&
                    (detallePagoForm.controls['detalle'].dirty ||
                    detallePagoForm.controls['detalle'].touched)">
                </p-message>
            </div>
            <div class="field col-12 md:col-6">
                <label for="fechaIniciofrm">Fecha de Inicio</label>
                <p-calendar #fechaIniciofrm="ngModel" inputId="fechaIniciofrm" name="fechaIniciofrm"
                            [(ngModel)]="planOrganizacion.fechaInicio"
                            (onSelect)="cargarDataPlanFechas($event)"
                            (onInput)="cargarDataPlanFechas($event)"
                            [minDate]="minDate" [maxDate]="planOrganizacion.fechaFin" 
                            [showTime]="appConfig.ux.calendar.showTime"
                            [showIcon]="appConfig.ux.calendar.showIcon" 
                            [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                            dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                            placeholder="{{appConfig.ux.calendar.dateFormat}}"
                            [disabled]="(!planOrganizacion|| !planOrganizacion.plan)"
                            required>
                </p-calendar>
            </div>
            <div class="field col-12 md:col-6">
                <label for="fechaFinfrm">Fecha de Finalización</label>
                <p-calendar #fechaFinfrm="ngModel" inputId="fechaFinfrm" name="fechaFinfrm"
                            [(ngModel)]="planOrganizacion.fechaFin"
                            [minDate]="planOrganizacion.fechaInicio"
                            [showTime]="appConfig.ux.calendar.showTime"
                            [showIcon]="appConfig.ux.calendar.showIcon" 
                            [showButtonBar]="appConfig.ux.calendar.showButtonBar" 
                            dateFormat="{{appConfig.ux.calendar.dateFormat}}"
                            placeholder="{{appConfig.ux.calendar.dateFormat}}"
                            [disabled]="(!planOrganizacion|| !planOrganizacion.plan || !planOrganizacion.fechaInicio)"
                            required>
                </p-calendar>
            </div>
            <!--Contraseñas generadas por el backend-->
            <div class="field col-12">
                <label for="detalle">Código de persona que le está activando:</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bars"></i>
                    <input
                        #nombre="ngModel"
                        id="codigoPersonaActivaPlan"
                        name="codigoPersonaActivaPlan"
                        type="text"
                        [(ngModel)]="planOrganizacion.codigoPersonaActivaPlan"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        pInputText
                        maxlength="20"
                        required
                        placeholder="Por ejemplo ingrese la cédula de la persona que activa el plan: 1103411359" />                        
                </span> 
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="detallePagoForm.controls['detalle'] &&
                    !detallePagoForm.controls['detalle'].valid &&
                    (detallePagoForm.controls['detalle'].dirty ||
                    detallePagoForm.controls['detalle'].touched)">
                </p-message>
            </div>


        </div>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button
                    pButton pRipple
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times" class="p-button-secondary"
                    (click)="mostrarFormaPagoSubject = false">
                </button>
                <button
                    pButton pRipple
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check" class="ml-1"
                    [disabled]="(!detallePagoForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---Diálogo de selección de subject--->
<p-dialog [(visible)]="mostrarPopupSubjects" 
          modal="modal" 
          showEffect="fade" 
          [breakpoints]="{ '960px': '45vw', '640px': '65vw' }"
          [style]="{ width: '45vw' }"
          (onHide)="mostrarPopupSubjects = false;">
    <ng-template pTemplate="header">
        <h4>              
            Personas/Entidades
        </h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-listbox [options]="subjectsFiltered" 
                   [(ngModel)]="planOrganizacion.subject" 
                   [metaKeySelection]="false"
                   (onClick)="cargarDataSubject($event)"
                   (onDblClick)="cargarDataSubject($event)"
                   emptyMessage="{{appConfig.ux.emptyMsg}}"
                   [filter]="false" filterPlaceHolder="Buscar por nombre o CI/RUC .."
                   emptyFilterMessage="{{appConfig.ux.emptyMsg}}"
                   [listStyle]="{'max-height':'300px'}">
            <ng-template  pTemplate="header">
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredSubjectByKeyword($event)"
                        placeholder="Buscar por nombre o CI/RUC .."
                        class="w-full"/>
                </span>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                    <div>
                        <img [src]="item.photo" *ngIf="item.photo"/>
                        <img src="/assets/layout/icons/user.png" *ngIf="!item.photo" style="width: 2rem"/>
                    </div>
                    <div class="p-ml-2">
                        <strong>{{item.initials}}</strong><br>
                        {{item.code}}<br>
                        {{item.email}}
                    </div>
                </div>
            </ng-template>  
            <ng-template  pTemplate="empty">
                <div class="p-text-center p-p-6">
                    <i *ngIf="!processFilter" class="pi pi-users" style="font-size: 4rem"></i>
                    <i *ngIf="processFilter && (!subjectsFiltered || !subjectsFiltered.length)"
                       class="pi pi-spin pi-spinner icon-secondary icon-md-4"></i>
                </div>  
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="col-12 p-d-flex p-flex-column p-flex-md-row p-jc-md-end table-header">
                    <button 
                        pButton
                        type="button"
                        pTooltip="{{ appConfig.ux.actions.create }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-sm"
                        (click)="nuevoContacto()"><!--[disabled]="!puedeEjecutar('crear')"-->
                    </button>
                </div>
            </ng-template>
        </p-listbox>
    </ng-template>
</p-dialog>
<!--Diálogos de creación/edición de subject--> 
<p-dialog
    [header]="subject && subject.id ? 'Editar Persona/Entidad' : 'Nueva Persona/Entidad'"
    [(visible)]="mostrarEditorSubject"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '85vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="mostrarEditorSubject = false">
    <form
        #subjectEditorForm="ngForm"
        (ngSubmit)="guardarContacto()"
        [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="uppercase">{{ subject.initials }}</h2>
            </div>
            <div class="p-field col-12">
                <label for="subjectCode">C.I/RUC</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-id-card"></i>
                    <input
                        #ciruc="ngModel"
                        id="ciruc"
                        name="ciruc"
                        type="text"
                        [(ngModel)]="subjectCode"
                        (keyup)="ui.onKey($event)"
                        [minlength]="10" [maxlength]="13"
                        required="true"
                        (blur)="searchSubjectPorCode($event);"
                        [pattern]="appConfig['validationRegExp']['cirucPattern']"
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['cirucPattern']"
                    *ngIf="
                    subjectEditorForm.controls['ciruc'] &&
                    !subjectEditorForm.controls['ciruc'].valid &&
                    (subjectEditorForm.controls['ciruc'].dirty ||
                    subjectEditorForm.controls['ciruc'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombres</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-user"></i>
                    <input
                        #nombre="ngModel"
                        id="nombre"
                        name="nombre"
                        type="text"
                        [(ngModel)]="subject.firstname"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        required
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="
                    subjectEditorForm.controls['nombre'] &&
                    !subjectEditorForm.controls['nombre'].valid &&
                    (subjectEditorForm.controls['nombre'].dirty ||
                    subjectEditorForm.controls['nombre'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="apellidos">Apellidos</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-user"></i>
                    <input
                        #apellidos="ngModel"
                        id="apellidos"
                        name="apellidos"
                        type="text"
                        [(ngModel)]="subject.surname"
                        [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                        required
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeTextPattern']"
                    *ngIf="
                    subjectEditorForm.controls['apellidos'] &&
                    !subjectEditorForm.controls['apellidos'].valid &&
                    (subjectEditorForm.controls['apellidos'].dirty ||
                    subjectEditorForm.controls['apellidos'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Correo electrónico</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-envelope"></i>
                    <input
                        #email="ngModel"
                        id="email"
                        name="email"
                        type="text"
                        (blur)="searchEmailByCode($event);"
                        [(ngModel)]="subject.email"
                        [pattern]="appConfig['validationRegExp']['emailPattern']"
                        required
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['emailPattern']"
                    *ngIf="
                    subjectEditorForm.controls['email'] &&
                    !subjectEditorForm.controls['email'].valid &&
                    (subjectEditorForm.controls['email'].dirty ||
                    subjectEditorForm.controls['email'].touched)
                    ">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Dirección</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input
                        #direccion="ngModel"
                        id="direccion"
                        name="direccion"
                        type="text"
                        [(ngModel)]="subject.description"
                        [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                        [maxlength]="appConfig.app.text.max_length"
                        pInputText />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    subjectEditorForm.controls['direccion'] &&
                    !subjectEditorForm.controls['direccion'].valid &&
                    (subjectEditorForm.controls['direccion'].dirty ||
                    subjectEditorForm.controls['direccion'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="mobil">Teléfono móvil</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-phone"></i>
                    <input
                        #mobil="ngModel"
                        id="mobil"
                        name="mobil"
                        type="text"
                        [(ngModel)]="subject.mobileNumber"
                        (keyup)="ui.onKey($event)"
                        [minlength]="7" [maxlength]="10"
                        [pattern]="appConfig['validationRegExp']['numberPattern']"
                        required="true"
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['numberPattern']"
                    *ngIf="
                    subjectEditorForm.controls['mobil'] &&
                    !subjectEditorForm.controls['mobil'].valid &&
                    (subjectEditorForm.controls['mobil'].dirty ||
                    subjectEditorForm.controls['mobil'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="work">Teléfono trabajo</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-phone"></i>
                    <input
                        #work="ngModel"
                        id="work"
                        name="work"
                        type="text"
                        [(ngModel)]="subject.workPhoneNumber"
                        (keyup)="ui.onKey($event)"
                        [minlength]="7" [maxlength]="10"
                        [pattern]="appConfig['validationRegExp']['numberPattern']"
                        required="false"
                        pInputText
                        [disabled]="subject && subject.id" />
                </span>
            </div>
            <!--Contraseñas generadas por el backend-->
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button
                    pButton
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="mostrarEditorSubject = false"></button>
                <button
                    pButton
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check" class="p-ml-lg-1"
                    [disabled]="(!subjectEditorForm.valid || !subjectCodeValid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>